import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import { AllocationRulesContext } from '../context';
import { getRulePrioritizationText } from '../rule-helper';
import SortFieldTotalDesc from './sort-field-total-desc';
import SortFieldTotalAsc from './sort-field-total-asc';
import SortFieldDateDesc from './sort-field-date-desc';
import SortFieldDateAsc from './sort-field-date-asc';

const RulePrioritizationDropdown = ({ allocationRuleId }) => {
  const { allocationRules } = useContext(AllocationRulesContext);
  const rule = allocationRules.find((r) => r.allocationRuleId === allocationRuleId);
  const rulePrioritizationText = getRulePrioritizationText(rule.sortDesc, rule.sortField);
  return (
    <DropdownMenu>
      <DropdownMenuToggler>{rulePrioritizationText}</DropdownMenuToggler>
      <SortFieldTotalDesc allocationRuleId={allocationRuleId} />
      <SortFieldTotalAsc allocationRuleId={allocationRuleId} />
      <SortFieldDateDesc allocationRuleId={allocationRuleId} />
      <SortFieldDateAsc allocationRuleId={allocationRuleId} />
    </DropdownMenu>
  );
};

RulePrioritizationDropdown.propTypes = {
  allocationRuleId: PropTypes.string.isRequired,
};

export default RulePrioritizationDropdown;
